var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gc-main-layout',{attrs:{"title":_vm.title,"isXSmall":_vm.isXSmall,"isLarge":_vm.isLarge}},[_c('div',[_c('h2',{staticClass:"content-block"},[_vm._v("Unauthorized!")]),_c('div',{staticClass:"content-block"},[_c('div',{staticClass:"view-card responsive-paddings"},[_c('router-link',{attrs:{"to":"/home"}},[_vm._v("Back to Home")])],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }